import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import classNames from 'classnames';
import can from '../../../_common/components/Permissions/can';
import {PopupCreateReceiptProvider} from '../../context/PopupCreateReceiptContext';
import CreateReceiptForm from './CreateReceiptForm';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

interface PopupCreateReceiptProps {
  _id: string,
  agentId: number,
  amount: number,
  customerEmail: string,
  customerID: string,
  customerName: string,
  status: number
  tableRowID: number
}

const PopupCreateReceipt = ({
                              _id,
                              agentId,
                              amount,
                              customerEmail,
                              customerID,
                              customerName,
                              status,
                              tableRowID
                            }: PopupCreateReceiptProps) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const isEnabled = can('full', 'invoices') && status === 1;

  const buttonClassName = classNames({[`opacity-30`]: !isEnabled});

  return (
    <PopupCreateReceiptProvider
      _id={_id}
      agentId={agentId}
      amount={amount}
      customerEmail={customerEmail}
      customerID={customerID}
      customerName={customerName}
      status={status}
      tableRowID={tableRowID}
    >
      <div
        className={buttonClassName}
        onClick={() => isEnabled && handleShowModal()}
        role="button"
      >
        <img
          src={toAbsoluteUrl('/media/svg/Receipt_brandColor.svg')}
          alt="icon"
          className={'w-20px h-20px'}
        />
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
        className="popupAddReceiptContainer"
      >
        <Modal.Body>
          <CreateReceiptForm closeModal={handleCloseModal}/>
        </Modal.Body>
      </Modal>
    </PopupCreateReceiptProvider>
  );
};

export default PopupCreateReceipt;
